import {
  AuthUser,
  AuthUserFromJSON,
  LoginRequest,
  LoginRequestToJSON
} from '@/api/models'
import * as runtime from '../runtime'

export class AuthApi extends runtime.BaseAPI {
  async login(request: LoginRequest): Promise<AuthUser> {
    const bodyParameters: runtime.HTTPBody = LoginRequestToJSON(request)

    const response = await this.requestPost(`/login`, bodyParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      AuthUserFromJSON(jsonValue)
    ).value()
  }

  async logout(): Promise<void> {
    const response = await this.requestPost(`/logout`)

    return new runtime.VoidApiResponse(response).value()
  }

  async me(): Promise<AuthUser> {
    const response = await this.requestGet(`/me`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      AuthUserFromJSON(jsonValue)
    ).value()
  }
}
